import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-grid";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return "[grid]" + shadowSelector + ",[grid]" + shadowSelector + " *" + shadowSelector + ",[grid]" + shadowSelector + " *" + shadowSelector + ":before,[grid]" + shadowSelector + " *" + shadowSelector + ":after {box-sizing: border-box;}h3" + shadowSelector + " {margin: 0 0 var(--sds-g-spacing-3) 0;}.divider" + shadowSelector + " {height: 4px;width: 80%;margin: 0;}p" + shadowSelector + " {margin: 0;padding-top: 1rem;}.highlight" + shadowSelector + " {white-space: pre-line;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];